import React from 'react';

import DateRangeInput from './DateRangeInput';
import InputText from './InputText';

const Form = (props) => {
  const {
    initialDate, finalDate, handleDate, cnpj, corporateName, clientERPCode, handleText, companyTag,
  } = props;

  return (
    <div className="margin-top-20" style={{ marginBottom: '17px' }}>
      <DateRangeInput
        initialDate={initialDate}
        finalDate={finalDate}
        handleDate={handleDate}
      />
      {companyTag === 'nortel' && (
        <React.Fragment>
          <div className="row">
            <div className="col-lg-6">
              <InputText
                title="cnpj"
                ariaDescription="cnpj"
                value={cnpj}
                fatherStateName="cnpj"
                handleText={handleText}
              />
            </div>
            <div className="col-lg-6">
              <InputText
                title="companyName"
                ariaDescription="razãoSocial"
                value={corporateName}
                fatherStateName="corporateName"
                handleText={handleText}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <InputText
                title="erpCode"
                ariaDescription="códigoERP"
                value={clientERPCode}
                fatherStateName="clientERPCode"
                handleText={handleText}
              />
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default Form;
